module.exports = __webpack_public_path__ + "static/media/logo_abbinarybag-darkmode.870dc741.png";